
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let cookieName = 'baltic-brand-cookies-agreed'
let $cookies = $('.cookie-consent')

$('body').on('click', '.js-confirm-cookie-consent', function (e){
  e.preventDefault()
  setCookie(cookieName, 1, 30)
  $cookies.fadeOut(300, function (){
    $cookies.remove()
  })
})

$('body').on('click', '.js-close-cookie-consent', function (e){
  e.preventDefault()
  $cookies.fadeOut(300, function (){
    $cookies.remove()
  })
})

if(getCookie(cookieName) === '1'){
  $cookies.remove()
} else {
  $cookies.removeClass('d-none')
}
